/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PriceEventQueueState = {
    Healthy: 'Healthy',
    Blocked: 'Blocked'
} as const;
export type PriceEventQueueState = typeof PriceEventQueueState[keyof typeof PriceEventQueueState];


export function instanceOfPriceEventQueueState(value: any): boolean {
    for (const key in PriceEventQueueState) {
        if (Object.prototype.hasOwnProperty.call(PriceEventQueueState, key)) {
            if (PriceEventQueueState[key as keyof typeof PriceEventQueueState] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PriceEventQueueStateFromJSON(json: any): PriceEventQueueState {
    return PriceEventQueueStateFromJSONTyped(json, false);
}

export function PriceEventQueueStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): PriceEventQueueState {
    return json as PriceEventQueueState;
}

export function PriceEventQueueStateToJSON(value?: PriceEventQueueState | null): any {
    return value as any;
}

export function PriceEventQueueStateToJSONTyped(value: any, ignoreDiscriminator: boolean): PriceEventQueueState {
    return value as PriceEventQueueState;
}

